export function getTopBid(bids:any){
    if(!bids)
        return 0
    let topBid = 0;
    for(let i=0;i<bids.length;i++){
        let val = Number(bids[i].value);
        if(val>topBid){
            topBid = val
        }
    }
    return topBid;
}

export function  getTopBidUser(bids:any, user:any){
    if(!bids)
        return 0
    let topBidUser = 0;
    for(let i=0;i<bids.length;i++){
        if(Number(bids[i].userId) != Number(user.uid)){
            continue
        }
        let val = Number(bids[i].value);
        if(val>topBidUser){
            topBidUser = val
        }
    }
    return topBidUser;
}
